import { PERMISSIONS, USER_ROLE } from './../constants/const';
import { getLocalStorageItem, setLocalStorageItem, removeLocalStorageItem, LocalStorageKey } from '../logic/classBrowserStrage';

const STORAGE_KEY: LocalStorageKey = 'hitzItems';

export interface LoginStrageInfo {
  sessionId: string;
  userId: number;
  role: number;
  branchId: number;
  subBranchId: number[];
  furnacesCount: number;
  userName: string;
  branchName: string;
  screenUrl: string;
}

export class LoginService {
  static setLoginInfo(resource: LoginStrageInfo) {
    setLocalStorageItem(STORAGE_KEY, resource);
  }

  static setScreenInfo(strUrl: string) {
    const loginInfo: LoginStrageInfo = LoginService.getLoginInfo();
    loginInfo.screenUrl = strUrl;
    setLocalStorageItem(STORAGE_KEY, loginInfo);
  }

  static getLoginInfo(): LoginStrageInfo & { permissions: number } {
    // ロールと権限のマッピング
    const getPermissionsByRole = (role: number) => {
      try {
        return Object.values(USER_ROLE)[role];
      } catch (e) {
        console.warn(e);
        return PERMISSIONS.NONE;
      }
    };

    const userInfo = getLocalStorageItem<LoginStrageInfo>(STORAGE_KEY) || {
      sessionId: '',
      userId: 0,
      role: -1,
      branchId: 0,
      subBranchId: [0],
      furnacesCount: 0,
      password: '',
      userName: '',
      branchName: '',
      screenUrl: '',
    };

    const response = {
      ...userInfo,
      permissions: getPermissionsByRole(userInfo.role),
    };

    // console.log(response);

    return response;
  }

  static removeLoginInfo() {
    removeLocalStorageItem(STORAGE_KEY);
  }
}
